import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components";
import ThemeProviderStyled from "../../theme/ThemeProvider.styled";

// styles
import  { GlobalErr, RefreshLink } from "./GlobalError.styled";

const GlobalError = ({ closeFunc, refreshPage }) => {
    return (
        <ThemeProvider theme={ThemeProviderStyled}>
            <GlobalErr>
                <div className="error-wrapper">
                    <p>
                        
                        <span>Sorry, an error occurred</span> 
                        {refreshPage ? (
                            <RefreshLink onClick={() => {
                                window.location.reload();
                            }}>Please refresh the page</RefreshLink>
                        ) : (
                            <>Please try again later</>
                        )}
                    </p>
                    <button type="button" onClick={closeFunc}>
                        <svg width="30" height="30"><g fill="#FFF" fillRule="nonzero"><path d="M15 29.897c8.205 0 14.897-6.666 14.897-14.897C29.897 6.77 23.205.103 15 .103S.103 6.795.103 15 6.795 29.897 15 29.897Zm0-27.692c7.051 0 12.795 5.744 12.795 12.795S22.05 27.795 15 27.795 2.205 22.05 2.205 15 7.95 2.205 15 2.205Z"/><path d="M9.41 20.436c.205.205.462.308.744.308s.538-.103.743-.308L15 16.333l4.103 4.103c.205.205.461.308.743.308s.539-.103.744-.308c.41-.41.41-1.077 0-1.487l-4.103-4.103 4.103-4.102a1.052 1.052 0 0 0-1.487-1.488L15 13.36l-4.103-4.103a1.052 1.052 0 0 0-1.487 1.488l4.103 4.102L9.41 18.95c-.41.41-.41 1.077 0 1.487Z"/></g></svg>
                    </button>
                </div>
            </GlobalErr>
        </ThemeProvider>
    );
};

export default GlobalError;

// props validation
GlobalError.propTypes = {
    /**
     * A function that is passed in to close the red banner
     */
    closeFunc: PropTypes.func.isRequired,
    /**
     * is this is true there will be a link to refresh the page
     */
    refreshPage: PropTypes.bool
};
